<div class="waec-page-header share-landing">
  <img
    class="waec-page-header-image"
    src="./assets/icons/Highlighted_Share.svg"
    alt="Highlighted Share"
  />
  <h3 class="waec-page-header-text">{{'PROVISIONING.SHARE.PAGE_TITLE' | translate}}</h3>

  <div *ngIf="isSmallScreen && !checkRoute" class="align-left page-header-menu">
    
    <ul nz-menu class="menu" nzMode="horizontal">
      <li 
        nz-menu-item
        #rla="routerLinkActive"
        [routerLinkActive]="'nav-active'"
      >
        <a 
          class="waec-card-header-txt text-capitalize"
          (click)="onClick()"
        >
          {{'PROVISIONING.SHARE.SHARE_HISTORY' | translate}}
        </a>
      </li>
    </ul>
  </div>
</div>

<div class="page-container" nz-row>
  <div class="share" id="share">
    <router-outlet></router-outlet>
  </div>
</div>


<!-- EXAM COUNTRY SETUP MODAL -->
<app-exam-country-setup *ngIf="examCountrySetupModal"
  (closeModal)="closeExamCountrySetupModal()"></app-exam-country-setup>